export default __webpack_public_path__ + "assets/images/4466651b75c6467c33b19890dbd03384.png";